<template lang="pug">
    extends ../base/base.pug
    block input
        b-row
            b-col(md)
                div
                    = '{{ question }}'
                    span(
                    v-if="is_required"
                    class="requiredField"
                    ) *
            b-col(md)
                v-select(
                v-model="selected_answer"
                @input="answer_changed"
                :required="is_required"
                :state="get_state"
                :options="options"
                label="text"
                taggable
                )
                b-form-invalid-feedback
                    = '{{ error_message }}'
                b-form-text
                    = '{{ helper }}'
</template>
<script>
import Base from "../dynamicDDL";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
	extends: Base,
	data() {
		return {
			selected_answer: null,
			watch_answer: true
		};
	},
	components: {
		"v-select": VueSelect
	},
	methods: {
		answer_changed() {
			if (
				this.selected_answer &&
				this.selected_answer.value !== this.local_answer
			) {
				this.local_answer = this.selected_answer.value;
				if (!this.selected_answer.value) {
					this.local_answer = this.selected_answer.text;
				}
				this.process_change();
			} else if (this.selected_answer === null && this.local_answer !== "") {
				this.local_answer = "";
				this.process_change();
			}
		},
		set_selected_answer(value) {
			this.watch_answer = false;
			if (value === "" || value === null) {
				this.selected_answer = null;
				return;
			}

			let found = this.options.find(function(element) {
				return element.value === value;
			});
			if (found !== undefined) {
				this.selected_answer = found;
			} else {
				this.selected_answer = {
					text: value,
					value: value
				};
			}
		}
	},
	watch: {
		local_answer(new_answer, old_answer) {
			if (this.watch_answer && old_answer === null) {
				this.set_selected_answer(new_answer);
			}
		},
		options() {
			if (this.selected_answer === null && this.local_answer) {
				this.set_selected_answer(this.local_answer);
			}
		}
	}
};
</script>
